import React, { useState, useRef, useEffect } from 'react';
import { motion, AnimatePresence } from 'framer-motion';

// Components
import Navbar from './components/Navbar';
import Hero from './components/Hero';
import About from './components/About';
import Expertise from './components/Expertise';
import Founder from './components/Founder';
import Contact from './components/Contact';
import Footer from './components/Footer';
import Spheres from './components/Spheres';
import ParticlesBackground from './components/ParticlesBackground';
import GalaxyBackground from './components/GalaxyBackground';

function App() {
  const appRef = useRef<HTMLDivElement>(null);

  return (
    <div ref={appRef} className="relative min-h-screen flex flex-col">
      {/* Background Elements */}
      <div className="fixed inset-0 overflow-hidden pointer-events-none z-[-1]">
        <div className="absolute inset-0 grid-pattern"></div>
      </div>
      <GalaxyBackground />
      <Spheres />
      <ParticlesBackground />

      {/* Main Content */}
      <div className="relative z-[1] flex-grow">
        <Navbar />
        <Hero />
        <About />
        <Expertise />
        <Founder />
        <Contact />
        <Footer />
      </div>
    </div>
  );
}

export default App;